import { SuretyAccountId } from "@inrev/common";
import { getDefaultTab, Tab, TabBar } from "@portal/components/ui/TabBar";
import { FC, useCallback, useState } from "react";
import { NonEmptyArray } from "../../../../shared/types";
import { AccountBondsTable } from "../AccountBondsTable";
import { AccountBondRequestsTable } from "./requests/AccountBondRequestsTable";

type BondSectionTab = { accountId: SuretyAccountId };

const BidBondsTab = ({ accountId }: BondSectionTab) => (
	<AccountBondsTable
		accountId={accountId}
		tableName="account_overview_bid_bonds"
		filterType="bid"
		status="open"
	/>
);

const FinalBondsTab = ({ accountId }: BondSectionTab) => (
	<AccountBondsTable
		accountId={accountId}
		tableName="account_overview_final_bonds"
		filterType="final"
		status="open"
	/>
);

const BOND_SECTION_TABS: NonEmptyArray<Tab<BondSectionTab>> = [
	{ id: "requests", label: "Requests", Component: AccountBondRequestsTable, isDefault: true },
	{ id: "bid-bonds", label: "Bid Bonds", Component: BidBondsTab },
	{ id: "final-bonds", label: "Final Bonds", Component: FinalBondsTab },
];

type AccountBondsAndRequestsProps = { accountId: SuretyAccountId };

export const AccountBondsAndRequests: FC<AccountBondsAndRequestsProps> = ({ accountId }) => {
	const [activeBondSectionTab, setActiveBondSectionTab] = useState(
		getDefaultTab(BOND_SECTION_TABS),
	);

	const handleTabChange = useCallback((id: string) => {
		const tab = BOND_SECTION_TABS.find((t) => t.id === id);
		if (tab) setActiveBondSectionTab(tab);
	}, []);

	const Component = activeBondSectionTab.Component;

	return (
		<div className="flex flex-col w-full space-y-2">
			<TabBar
				options={BOND_SECTION_TABS}
				activeTabId={activeBondSectionTab.id}
				onTabChange={handleTabChange}
			/>
			<Component accountId={accountId} />
		</div>
	);
};
